<div *ngIf="error" class="alert alert-warning">
  {{error}}
</div>

<form class="form signup" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="row">
    <div class="col-6">
      <form-field class="front" label="First Name" i18n-label="@@front.register.firstName.label">
        <input type="text" formControlName="firstName" placeholder="Your first Name" i18n-placeholder="@@front.register.firstName.placeholder">
      </form-field>
    </div>
    <div class="col-6">
      <form-field class="front" label="Last Name" i18n-label="@@front.register.lastName.label">
        <input type="text" formControlName="lastName" placeholder="Your last name" i18n-placeholder="@@front.register.lastName.placeholder">
      </form-field>
    </div>
  </div>
  <form-field class="front" label="Email" i18n-label="@@front.register.email.label">
    <input type="email" formControlName="email" placeholder="Your email address" i18n-placeholder="@@front.register.email.placeholder">
  </form-field>
  <password-complexity
    formControlName="password"
    label="Password"
    placeholder="Enter your password"
    i18n-label="@@front.register.password.label"
    i18n-placeholder="@@front.register.password.placeholder"
  ></password-complexity>
  <p class="bg-gray text-center">
    <ng-container i18n="@@front.register.agreement">
      By proceeding, you are agreeing to our
      <a routerLink="/page/terms-of-service">Terms of Service</a>
      and
      <a routerLink="/page/privacy-policy">Privacy policy</a>
    </ng-container>
  </p>
  <button type="submit" class="btn btn-front btn-lg btn-primary d-block w-100 mb-3" [disabled]="!form.valid || loading">
    <ng-container *ngIf="loading" i18n="@@front.register.loadingSubmit">Loading ...</ng-container>
    <ng-container *ngIf="!loading" i18n="@@front.register.SubmitButton">Sign Up</ng-container>
  </button>
  <div class="bg-gray text-center">
    <ng-container i18n="@@front.register.loginText">Already have an account? <a routerLink="/login">Login</a></ng-container>
  </div>

  <!-- <p *ngIf="referralId" class="text-sm text-gray text-center mt-3" i18n="@@front.register.referralText">You have been referred by <strong>{{referralId}}</strong>. You can both earn rewards with every deposit and digital asset buy orders</p> -->
</form>
